import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getCurrentOrganisationShapeSets(organisationId, isAllocatedTo=true, shapeType=undefined, excludeArchived=false, excludeMissingRefName=false) {
  return function(dispatch, getState) {
    const endpoint = '/shapesets';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        isAllocatedTo,
        excludeArchived,
        excludeMissingRefName
      }
    };

    if (shapeType) {
      options.params.shapeType = shapeType;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const shapeSets = response.data.shapeSets;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_ORG_ALLOCATED_SHAPESETS' : 'UPDATE_CURRENT_ORG_UNALLOCATED_SHAPESETS';
        dispatch({ type, shapeSets });
      },
      error => dispatch(APIError(error, 'Error getting shapesets'))
    );
  };
}

export function addShapeSetToCurrentOrganisation(shapeSetId, organisationId) {
  return function(dispatch, getState) {
    const endpoint = '/shapeset/membership/organisation';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        shapeSetId,
        organisationId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCurrentOrganisationShapeSets(organisationId, true));
        dispatch(getCurrentOrganisationShapeSets(organisationId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error adding shapeset to currentOrganisation'))
    );
  }
}

export function removeShapeSetFromCurrentOrganisation(shapeSet, organisationId) {
  return function(dispatch, getState) {
    const endpoint = `/shapeset/membership/organisation/${shapeSet.membershipId}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCurrentOrganisationShapeSets(organisationId, true));
        dispatch(getCurrentOrganisationShapeSets(organisationId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing shapeset from currentOrganisation'))
    );
  }
}



// WEBPACK FOOTER //
// ./src/actions/organisations/shapeSetCreators.js